namespace TabAurous.Administration {
    export namespace AuthorizedVouchersService {
        export const baseUrl = 'Administration/AuthorizedVouchers';

        export declare function Create(request: Serenity.SaveRequest<AuthorizedVouchersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AuthorizedVouchersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AuthorizedVouchersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AuthorizedVouchersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Administration/AuthorizedVouchers/Create",
            Update = "Administration/AuthorizedVouchers/Update",
            Delete = "Administration/AuthorizedVouchers/Delete",
            Retrieve = "Administration/AuthorizedVouchers/Retrieve",
            List = "Administration/AuthorizedVouchers/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>AuthorizedVouchersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
